import React from "react";
import { useTranslation } from "react-i18next";
import { styled } from "goober";

import { readState } from "@/__main__/app-state.mjs";
import blitzMessage, { EVENTS } from "@/__main__/ipc-core.mjs";
import { possibleUpdateStateValues } from "@/app/util.mjs";
import InstallIcon from "@/inline-assets/update-available.svg";
import { useSnapshot } from "@/util/use-snapshot.mjs";

export const Button = styled("button")`
  --btn-hsl: var(--green-hsl);
  position: relative;
  padding: var(--sp-0_5);
  background: hsl(var(--btn-hsl) / 15%);
  color: hsl(var(--btn-hsl) / 100%);
  cursor: pointer;

  &:hover {
    background: hsl(var(--btn-hsl) / 25%);
  }
`;

const UpdateAvailableButton = () => {
  const { t } = useTranslation();
  const {
    volatile: { updateStatus },
  } = useSnapshot(readState);

  const updateAvailable =
    updateStatus || possibleUpdateStateValues.includes(updateStatus);

  if (!updateAvailable) {
    return null;
  }

  return (
    <Button
      className="button"
      onClick={() => {
        if (updateStatus === "ota-available") {
          blitzMessage(EVENTS.APP_RESTART);
        } else {
          blitzMessage(EVENTS.APPLY_UPDATE);
        }
      }}
      data-tooltip={t("common:updateAvailable", "Update available")}
    >
      <InstallIcon />
    </Button>
  );
};

export default UpdateAvailableButton;
